import { useContext } from 'react';

import { HistogramSelectConfigContext } from '../contexts/HistogramSelectConfigContext.js';

export const useHistogramSelectConfig = () =>
  useContext(HistogramSelectConfigContext);
